import { CustomClients } from '@thehubz/shared/branding';
import { AnyType } from '@thehubz/shared/model';

export interface FilterFormDataModel {
  title: string;
  description: string;
  customClient: CustomClients;
  applicationData?: AnyType;
  formFields: FormField[];
}

export interface FormField {
  regex?: string;
  minDate?: Date;
  maxDate?: Date;
  formTypeId: string;
  fieldLabel: string;
  inputType?: string;
  maxlength?: number;
  minlength?: number;
  placeholder: string;
  fieldGroup?: string;
  mandatory?: boolean;
  fieldType: FieldType;
  formFieldName: string;
  sharingFlag?: boolean;
  widthClass?: WidthClass | string;
  validationRegex?: string;
  subProjectFlag?: boolean;
  formFieldGroup?: FormField[];
  enableMatOptGroup?: boolean;
  repeatFieldLabel?: boolean; // for formArray
  dropDownSearch?: boolean;
  usageRightFlag?: boolean;
  matDivider?: number;
  sortDataSource?: boolean;
  duplicateFlag?: boolean;
  functionCall?: boolean;
  assetType?: string[];
  projectType?: string;
  formGroup?: boolean;
  hideLabel?: boolean;
  editable?: boolean;
  multiple?: boolean;
  editView?: boolean;
  visible?: boolean;
  options?: AnyType;
  disable?: boolean;
  value?: AnyType;
}

export enum FieldType {
  Date = 'date',
  Text = 'text',
  Number = 'number',
  Divider = 'divider',
  Textarea = 'textarea',
  Dropdown = 'dropdown',
  MatChipList = 'matChipList',
  AssetGallery = 'assetGallery',
  AssetRelation = 'assetRelation',
  MultiSelectChip = 'multiSelectChip',
  MatChipListNoAutocomplete = 'matChipListNoAutocomplete',
  SelectCheckBox = 'selectCheckBox',
  AutoComplete = 'autoComplete',
  DropdownTime = 'dropdownTime',
  FormArray = 'formArray',
  Checkbox = 'checkbox',
  Duration = 'duration',
  Domains = 'domains',
  Label = 'label',
  Space = 'space',
}

export enum WidthClass {
  W11 = 'w-2/3',
  W12 = 'w-1/2',
  W13 = 'w-1/3',
  W14 = 'w-1/4',
  W34 = 'w-3/4',
  W15 = 'w-1/5',
  W16 = 'w-1/6',
  WFull = 'w-full',
  SelfCenter = 'self-center',
  ColSpanFull = 'col-span-full',
}
